import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataQuery } from '../models/data-query.model';

@Component({
    selector: 'app-warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.css']
})
export class WarningDialogComponent implements OnInit {

    // Injected Properties
    warningMessage: string;
    allowOverwrite = false;
    query: DataQuery;
    existingQueryId: number;
    dataQueryService: any;	// This is an instance of the data query service and must be any to prevent circular dependency issues

    // Properties

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<WarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    // Event Functions
    ngOnInit() {
        this.warningMessage = this.data.warningMessage;
        this.allowOverwrite = this.data.allowOverwrite;
        this.dataQueryService = this.data.dataQueryService;
        this.query = this.data.query;
        this.existingQueryId = this.data.existingQueryId;
    }

    overwrite() {
        // PRE: the overwrite button is clicked, and there is query and existingQueryId
        // POST: attempts to overwrites the query. Closes with true on success. Closes with false on failure.
        this.query.ID = this.existingQueryId;
        this.dataQueryService.saveQuery(this.query,
            (result) => {
                if (result) {
                    this.dataQueryService.loadQuery(this.query);
                }
                this.dialogBox.close(true);
            },
            () => {
                this.dialogBox.close(false);
            }
        );
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog box
        this.dialogBox.close(false);
    }

    // Methods
}
